<div class="table-selection-dialog">
  <sc-flex vertical stretchContent fitHeight>
    <sc-dialog-title>{{data.title}}</sc-dialog-title>
    <div class="top-info"></div>
    <sc-flex-fitting-content vertical>
      <sc-padding fitHeight>
        <sc-tmc-table [tableModel]="tableModel" #tmcTableComponent></sc-tmc-table>
      </sc-padding>
    </sc-flex-fitting-content>
    <sc-actionbar>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button (click)="cancelDialog()"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-confirm-button (click)="confirm()"></sc-confirm-button>
    </sc-actionbar>
  </sc-flex>
</div>
